module.exports = __webpack_public_path__ + "clickup-3-ad6e54e3cc61e3444537f6d16faac3b2.webp";